/**
 * Simple Web Audio helpers for scanner feedback.
 * No external audio files — synthesized in-browser so it works offline.
 */

let _audioCtx = null;

function _getCtx() {
  if (typeof window === "undefined") return null;
  if (!_audioCtx) {
    // Some browsers require user gesture before creating AudioContext.
    // We create lazily on first play.
    try {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      _audioCtx = new Ctx();
    } catch {
      return null;
    }
  }
  // Some browsers pause audio when tab is backgrounded — resume on demand.
  if (_audioCtx.state === "suspended") {
    _audioCtx.resume().catch(() => {});
  }
  return _audioCtx;
}

function _tone({ freq, duration, volume = 0.35, type = "sine", startAt = 0 }) {
  const ctx = _getCtx();
  if (!ctx) return;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  osc.connect(gain);
  gain.connect(ctx.destination);
  const t0 = ctx.currentTime + startAt;
  gain.gain.setValueAtTime(0, t0);
  gain.gain.linearRampToValueAtTime(volume, t0 + 0.005);
  gain.gain.linearRampToValueAtTime(0, t0 + duration - 0.005);
  osc.start(t0);
  osc.stop(t0 + duration);
}

/** Short cheerful "ding" — success feedback. */
export function playSuccessBeep() {
  _tone({ freq: 880, duration: 0.11, volume: 0.35 });
  _tone({ freq: 1320, duration: 0.15, volume: 0.35, startAt: 0.08 });
}

/**
 * Loud alarm — 3 alternating tones simulating a warning buzzer.
 * Used for SPB palsu / invalid scans.
 */
export function playAlarmBeep() {
  _tone({ freq: 440, duration: 0.18, volume: 0.5, type: "square" });
  _tone({ freq: 220, duration: 0.18, volume: 0.5, type: "square", startAt: 0.20 });
  _tone({ freq: 440, duration: 0.18, volume: 0.5, type: "square", startAt: 0.40 });
  _tone({ freq: 220, duration: 0.30, volume: 0.5, type: "square", startAt: 0.60 });
}

/** Neutral chime — used when SPB already verified (no action needed). */
export function playInfoBeep() {
  _tone({ freq: 660, duration: 0.12, volume: 0.3 });
}
